import { circleTimeMap } from "./circleTimeMap";
import { clusterMap } from "./clusterMap";
import { heatMap } from "./heatMap";
import { hexBinMap } from "./hexBinMap";
import { pointMap } from "./pointMap";
import { pointStaticMap } from "./pointStaticMap";
import { pointTimeMap } from "./pointTimeMap";

const MapFunction = (mode) => {
    if(mode === "pointMap") {
        return pointMap;
    } else if(mode === "hexBinMap") {
        return hexBinMap;
    } else if(mode === "clusterMap") {
        return clusterMap;
    } else if(mode === "heatMap") {
        return heatMap;
    } else if(mode === "pointStatisticsMap") {
        return pointStaticMap;
    } else if(mode === "pointTimeMap") {
        return pointTimeMap;
    } else if(mode === "circleTimeMap") {
        return circleTimeMap;
    }

}

export default MapFunction;